module.exports = __webpack_public_path__ + "static/ca_advertising_annual_2015.5433c626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ca_advertising_annual_2015.jpg
// module id = 663
// module chunks = 174759553322802